export const isHeadache = symptom => symptom.name === 'headache'

export const isRunnyNose = symptom => symptom.name === 'runnyNose'

export const isMalaise = symptom => symptom.name === 'malaise'
